"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTagPrimary: function() {
        return _InteractionTagPrimary.InteractionTagPrimary;
    },
    interactionTagPrimaryClassNames: function() {
        return _useInteractionTagPrimaryStylesstyles.interactionTagPrimaryClassNames;
    },
    renderInteractionTagPrimary_unstable: function() {
        return _renderInteractionTagPrimary.renderInteractionTagPrimary_unstable;
    },
    useInteractionTagPrimaryStyles_unstable: function() {
        return _useInteractionTagPrimaryStylesstyles.useInteractionTagPrimaryStyles_unstable;
    },
    useInteractionTagPrimary_unstable: function() {
        return _useInteractionTagPrimary.useInteractionTagPrimary_unstable;
    }
});
const _InteractionTagPrimary = require("./InteractionTagPrimary");
const _renderInteractionTagPrimary = require("./renderInteractionTagPrimary");
const _useInteractionTagPrimary = require("./useInteractionTagPrimary");
const _useInteractionTagPrimaryStylesstyles = require("./useInteractionTagPrimaryStyles.styles");
